module.exports = __webpack_public_path__ + "static/media/MTH_Low_Impact_Dance_Fitness_1.53f5dde4.webp";